export const cvvEvent = ["abnormal", "tampered"];
